// Copyright (c) 2019 Deere & Company

import actions from '../actions-list';

export const updatePipNumber = pipNumber => ({
    pipNumber,
    type: actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_NUMBER
});



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/update-pip-number.js